import BaseController from './base_controller'

export default class extends BaseController {
  static values = { imo: String, system: String, type: String, staleTooltip: String }

  connect() {
    this.form = this.element.closest('form')
    this.onFormInput = this.markStale.bind(this)
    this.form?.addEventListener('input', this.onFormInput)
  }

  disconnect() {
    this.form?.removeEventListener('input', this.onFormInput)
    this.tooltip?.dispose()
  }

  markStale(event) {
    if (this.stale || !event.target.name?.startsWith('vessel[')) return

    this.stale = true
    this.element.classList.add('disabled')
    this.tooltip = new bootstrap.Tooltip(this.element, { title: this.staleTooltipValue })
  }

  open() {
    if (this.stale) return

    this.showLoading()
    $.ajax({
      type: 'POST',
      url: `/calculator/${this.systemValue}/${this.typeValue}/sensitivity-matrix?imo=${this.imoValue}`,
      data: $(this.form).serialize(),
      dataType: 'script',
      error: (_xhr, status, error) => console.error('Sensitivity matrix request failed:', status, error)
    })
  }
}
